import { environment } from "../../environments/environment";

export class URLS {
    public static BASE_URL = environment.TQR_SERVICE + 'toqqer';

    //toqqer auth
    public static authMethods = environment.TQR_SERVICE + 'toqqerauth/auth-methods';
    public static verifyPhonenumber = environment.TQR_SERVICE + 'toqqerauth/initiatephoneverification';
    public static verifyOtp = environment.TQR_SERVICE + 'toqqerauth/verifyotp';
    public static guestToken = environment.TQR_SERVICE + 'toqqerauth/guesttoken';
    public static userLogin = environment.TQR_SERVICE + 'UserController/userLogin';
    public static authenticate = environment.TQR_SERVICE + 'authenticatelt';
    public static createUser = environment.TQR_SERVICE + 'UserController/userCreate';
    public static updateUser = URLS.BASE_URL + '/services/updateUser';
    public static uploadProfileImage = URLS.BASE_URL +'/services/imageUpload';
    public static profileImageBaseUrl = environment.profile_thumb;
    public static uniqueUser = URLS.BASE_URL + '/services/uniqueUserName'

    //International auth
    public static internationalAuthSignIn = environment.TQR_SERVICE + 'africa/toqqerauth/loginuser';
    public static internationalAuthRegister = environment.TQR_SERVICE + 'africa/toqqerauth/registration';
    public static authCheck = environment.TQR_SERVICE + 'auth/check';
    public static authMethod = environment.TQR_SERVICE +'toqqerauth/auth-methods';
    
    public static getVideoByCategory = URLS.BASE_URL + '/services/getVideoByCategory';
    public static getSectionsContent = URLS.BASE_URL + '/services/getPrimeLibraryBySection';
    public static getPrimeChannel = environment.TQR_SERVICE + 'channels/getPrimeChannel';
    public static getCcPrimeSectionContent = URLS.BASE_URL + '/services/getCcPrimeVideoLibrary';
    public static getSectionContentById = URLS.BASE_URL + '/services/getPrimeLibraryForSection';
    public static setUserStatus = URLS.BASE_URL + '/services/setUserStatus';
    public static userLikedVideos = URLS.BASE_URL + '/services/userLikedVideos';
    public static followTimeLineUser = URLS.BASE_URL + '/services/followTimelineUser';
    public static getJwtToken = environment.TQR_SERVICE + '/UserController/userDetailsByFbToken'; 
    public static getUserContent = URLS.BASE_URL + '/services/userTrackDetails';
    public static addInWatchList = URLS.BASE_URL + '/services/addWatchList';
    public static removeFromWatchList = URLS.BASE_URL + '/services/deleteWatchList';
    public static getAllChannelInfo = environment.TQR_SERVICE + '/CSController/getAllChannel';
    public static getChannelData = environment.TQR_SERVICE + 'CSController/getAllChannelWithFeatuers'
    public static getSearchContent = URLS.BASE_URL + '/services/getSolrData';
    public static getSolrSearch = URLS.BASE_URL + '/services/getSolrSearch';
    public static getSearchHistory = URLS.BASE_URL + '/services/getSearchHistory';

    public static updateUserWatchHistory=URLS.BASE_URL+'/services/addVideoHistoryForUser';
    public static getUserWatchHistory=URLS.BASE_URL+'/services/getHistoryListForUser';
    public static insertWatchHistory = environment.TQR_SERVICE + 'watch-history';
    public static getWatchHistory = environment.TQR_SERVICE + 'watch-history';
    public static getContinueWatching = environment.TQR_SERVICE + 'watch-history?mode=continue_watching';
    public static deleteWatchHistoryEntry = environment.TQR_SERVICE + 'watch-history/videos/';
    public static getUserWatchList=URLS.BASE_URL+'/services/getWatchListForUser';
    public static videoPlayBackUrl = URLS.BASE_URL + '/services/tracking?eventType=13';
    public static trackDrmLicence = environment.TQR_SERVICE + 'api/tqr-track/drmLicence';
    public static channelIconBaseUrl = URLS.BASE_URL + '/static/public/channels/CH_';
    public static channelIconThumbUrl = '_thumb.jpg';
    public static getDeleteProfile = URLS.BASE_URL +'/services/deleteUser';
       
    //series endpoints
    public static getEpisodicConent =  URLS.BASE_URL + '/services/getEpisodicContentForWeb';

    //cc_prime endpoints
    public static getCcPrimeVideoLibrary = URLS.BASE_URL + '/services/getCcPrimeVideoLibrary';
    public static getCcPrimeVideoCategory = URLS.BASE_URL + '/services/getCcPrimeVideosForCategory';
    public static getCCPrimeChannelVideos = URLS.BASE_URL + '/services/getAllVideoForChannel';
    public static getCcPrimeVideosForCategory = URLS.BASE_URL + '/services/getCcPrimeVideosForCategory';

    //toqqer wallet
    public static getTqrWallet = environment.TQR_SERVICE + 'finance/wallet/getTqrWalletByWalletId';
    public static topUpWallet = environment.TQR_SERVICE + 'finance/wallet/topUp';
    public static walletToWallet = environment.TQR_SERVICE +'finance/wallet/walletToWalletTransfer';

    //subscription
    public static subscribeFromWallet = environment.TQR_SERVICE + 'finance/subscription/subscriptionFromWallet';
    public static subscribeFromCashfree = environment.TQR_SERVICE + 'finance/subscription/subscriptionFromCashfreePayment';
    public static toqqerPayment = environment.TQR_SERVICE + 'finance/subscription/initiateSubscription';
    public static getUserSubscriptions = environment.TQR_SERVICE + 'CSController/getAllUserSubTransactions';
    public static createOrder = URLS.BASE_URL + '/createOrder';
    public static useSubscriptions = environment.TQR_SERVICE + 'finance/subscription/getUserSubscription'; 
    // public static orderStatus = environment.TQR_SERVICE + 'finance/subscription/getCashfreeStatus';
    public static orderStatus = environment.TQR_SERVICE + 'finance/subscription/getPaymentStatus';

    //pervious
    public static getWalletOrderToken = environment.TQR_SERVICE + 'wallet/getWalletOrderToken';
    public static getOrderToken = environment.TQR_SERVICE + 'PMController/getOrderToken';
    public static getTransaction = environment.TQR_SERVICE + 'finance/wallet/getTransactionHistory'

    //reportings
    public static getReportTypes = environment.TQR_SERVICE + 'lookup/REPORT_TYPE';
    public static reportAbuse = environment.TQR_SERVICE + 'report-abuse';

    //filtering
    public static webSearch = environment.TQR_SERVICE + 'webSearch';
    public static getChannelId = environment.TQR_SERVICE + 'channels/getChannelId';

    public static imgUrl = environment.flix_thumb;
    public static channelUrl = environment.channel_thumb;
    public static mediaUrl = environment.flix_video;

    public static logout = environment.TQR_SERVICE + 'toqqerauth/logoutdevice';

    public static getGenres = environment.baseUrl + 'cms/MasterDataController/getGenre';

    //live streaming
    public static liveStreams = environment.TQR_SERVICE + 'api/v1/live/streams';
    public static liveStreamDetail = environment.TQR_SERVICE + 'api/v1/live/streams/';
    public static liveDrmProxy = environment.TQR_SERVICE + 'api/drm/license/widevine';
}